import React, { Component } from 'react';


// Import Images
import bg1 from '../../images/background/line-bg1.png';
import ptImg1 from '../../images/shap/circle-orange.png';
import ptImg2 from '../../images/shap/plus-orange.png';
import ptImg3 from '../../images/shap/circle-dots.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp5 work-area" style={{backgroundImage: "url("+bg1+")", backgroundRepeat:" no-repeat", backgroundPosition: "center", backgroundSize: "100%"}}>
					<div className="container-sm container-smServ">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Tratamiento Médico</h6>
							<h2 className="title">Cómo trabajamos?</h2>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-3 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-num-bx">01</div>
									<div className="work-content">
										<h5 className="title text-secondary mb-10">Agende una Cita</h5>
										<p>Agende una cita en Doctoralia, en donde podrá elegir el día y horario que más le convenga.</p>
									</div>
									<a target="_blank" rel="noreferrer"  href="https://www.doctoralia.com.mx/eduardo-alvarez-del-castillo-sanchez/cirujano-general/aguascalientes" className="btn btn-primary shadow">Ver más<i className="btn-icon-bx fas fa-chevron-right"></i></a>
								</div>
							</div>
							<div className="col-lg-3 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-num-bx">02</div>
									<div className="work-content">
										<h5 className="title text-secondary mb-10">Diagnóstico</h5>
										<p>En su cita inicial, realizaremos lo necesario para llegar a un diagnóstico acertado.</p>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-num-bx">03</div>
									<div className="work-content">
										<h5 className="title text-secondary mb-10">Reevaluación</h5>
										<p>Realizaremos la revisión de resultados de estudios solicitados, corroborando el diagnóstico y tratamiento sugerido.</p>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-sm-6 mb-30">
								<div className="work-bx active">
									<div className="work-num-bx">04</div>
									<div className="work-content">
										<h5 className="title text-secondary mb-10">Seguimiento</h5>
										<p>Vigilaremos su evolución hasta su total recuperación.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate3" src={ptImg3} alt=""/>
				</section>
				
			</>
		);
	}
}

export default aboutSection;
